import { styled } from '@abyss/web/tools/styled';
import { Layout } from '@abyss/web/ui/Layout';
import { Text } from '@abyss/web/ui/Text';

export const StyledLocationHeader = styled(Layout.Stack, {
  marginLeft: '4px',
  color: '$gray7',
  fontSize: '16px',
  fontWeight: 500,
  '&.abyss-layout-stack': {
    alignItems: 'flex-start',
    'div:nth-of-type(2)': {
      position: 'relative',
      top: '8px',
    },
  },
});

export const StyledLocationSearchInstructionsText = styled(Text, {
  color: '$gray7',
  size: '$md',
  fontWeight: 500,
});
